import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between h-full items-center px-5" }

import { useRoute } from "vue-router";
import { DbIcon } from "@db-ui/v-elements-enterprise/dist/components";
// TODO - change done icon back to check-circle


export default /*@__PURE__*/_defineComponent({
  __name: 'AppFooter',
  setup(__props) {

const route = useRoute();

const activePage = (page) => {
  return route.name === page;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: "/",
      class: _normalizeClass([activePage('assignments') ? 'text-white' : 'text-gray-400', "flex active flex-col cursor-pointer transition-transform duration-300 transform hover:scale-105"])
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DbIcon), {
          icon: "more-vertical",
          variant: "32-outline",
          class: "hydrated"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("main.assignments")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: "/tour",
      class: _normalizeClass([activePage('tour') ? 'text-white' : 'text-gray-400', "flex flex-col cursor-pointer transition-transform duration-300 transform hover:scale-105"])
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DbIcon), {
          icon: "round-trip",
          variant: "32-outline",
          class: "hydrated"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("main.tour")), 1)
      ]),
      _: 1
    }, 8, ["class"]),
    _createVNode(_component_router_link, {
      to: "/done",
      class: _normalizeClass([activePage('done') ? 'text-white' : 'text-gray-400', "flex flex-col cursor-pointer transition-transform duration-300 transform hover:scale-105"])
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DbIcon), {
          icon: "check-circle",
          variant: "32-outline",
          class: "hydrated"
        }),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t("main.completed")), 1)
      ]),
      _: 1
    }, 8, ["class"])
  ]))
}
}

})